@switch (matType()) {
  @case (MatButtonType.RAISED) {
    <button
      [type]="buttonType()"
      mat-raised-button
      [color]="color()"
      [routerLink]="routerLink() || null"
      [queryParams]="queryParams()"
      [matMenuTriggerFor]="menuTriggerFor()"
      (click)="emitClick($event)"
      [ngClass]="{
        'mat-error': color() === 'error',
        'mat-warn': color() === 'warn',
        'mat-success': color() === 'success',
        'mat-info': color() === 'info',
      }"
      class="z-button-base"
      [class.w-100]="!isFabType()"
      [disabled]="disabled()"
      [matTooltip]="resolvedTooltip()"
      [attr.aria-label]="resolvedAriaLabel()"
    >
      @if (icon()) {
        <mat-icon class="s-me-1"> {{ icon() }} </mat-icon>
      }
      @if (label()) {
        <span>{{ label() | translate }}</span>
      }
      <ng-content></ng-content>
    </button>
  }

  @case (MatButtonType.STROKED) {
    @if (isLinkMode()) {
      <a
        mat-stroked-button
        [color]="color()"
        [href]="href()"
        [attr.target]="target() || null"
        [attr.rel]="rel() || null"
        (click)="emitClick($event)"
        [ngClass]="{
          'mat-error': color() === 'error',
          'mat-warn': color() === 'warn',
          'mat-success': color() === 'success',
          'mat-info': color() === 'info',
        }"
        class="z-button-base"
        [class.w-100]="!isFabType()"
        [matTooltip]="resolvedTooltip()"
        [attr.aria-label]="resolvedAriaLabel()"
      >
        @if (icon()) {
          <mat-icon class="s-me-1">{{ icon() }}</mat-icon>
        }
        @if (label()) {
          <span>{{ label() | translate }}</span>
        }
        <ng-content></ng-content>
      </a>
    } @else {
      <button
        [type]="buttonType()"
        mat-stroked-button
        [color]="color()"
        [routerLink]="routerLink() || null"
        [queryParams]="queryParams()"
        [matMenuTriggerFor]="menuTriggerFor()"
        (click)="emitClick($event)"
        [ngClass]="{
          'mat-error': color() === 'error',
          'mat-warn': color() === 'warn',
          'mat-success': color() === 'success',
          'mat-info': color() === 'info',
        }"
        class="z-button-base"
        [class.w-100]="!isFabType()"
        [disabled]="disabled()"
        [matTooltip]="resolvedTooltip()"
        [attr.aria-label]="resolvedAriaLabel()"
      >
        @if (icon()) {
          <mat-icon class="s-me-1"> {{ icon() }} </mat-icon>
        }
        @if (label()) {
          <span>{{ label() | translate }}</span>
        }
        <ng-content></ng-content>
      </button>
    }
  }

  @case (MatButtonType.MENU) {
    <button
      [type]="buttonType()"
      mat-button
      [color]="color()"
      [routerLink]="routerLink() || null"
      [queryParams]="queryParams()"
      [matMenuTriggerFor]="menuTriggerFor()"
      (click)="emitClick($event)"
      [ngClass]="{
        'mat-mdc-menu-item mdc-list-item': true,
        'mat-error': color() === 'error',
        'mat-warn': color() === 'warn',
        'mat-success': color() === 'success',
        'mat-info': color() === 'info',
      }"
      class="z-button-base"
      [class.w-100]="!isFabType()"
      [disabled]="disabled()"
      [matTooltip]="resolvedTooltip()"
      [attr.aria-label]="resolvedAriaLabel()"
    >
      @if (icon()) {
        <mat-icon class="s-me-1"> {{ icon() }} </mat-icon>
      }
      @if (label()) {
        <span>{{ label() | translate }}</span>
      }
      <ng-content></ng-content>
    </button>
  }

  @case (MatButtonType.FAB) {
    <button
      [type]="buttonType()"
      mat-fab
      [color]="color()"
      [routerLink]="routerLink() || null"
      [queryParams]="queryParams()"
      [matMenuTriggerFor]="menuTriggerFor()"
      (click)="emitClick($event)"
      [ngClass]="{
        'mat-error': color() === 'error',
        'mat-warn': color() === 'warn',
        'mat-success': color() === 'success',
        'mat-info': color() === 'info',
      }"
      class="z-button-base"
      [disabled]="disabled()"
      [matTooltip]="resolvedTooltip()"
      [attr.aria-label]="resolvedAriaLabel()"
    >
      @if (icon()) {
        <mat-icon>{{ icon() }}</mat-icon>
      }
      @if (!icon() && label()) {
        <span>{{ label() | translate }}</span>
      }
      <ng-content></ng-content>
    </button>
  }

  @case (MatButtonType.MINI_FAB) {
    <button
      [type]="buttonType()"
      mat-mini-fab
      [color]="color()"
      [routerLink]="routerLink() || null"
      [queryParams]="queryParams()"
      [matMenuTriggerFor]="menuTriggerFor()"
      (click)="emitClick($event)"
      [ngClass]="{
        'mat-error': color() === 'error',
        'mat-warn': color() === 'warn',
        'mat-success': color() === 'success',
        'mat-info': color() === 'info',
      }"
      class="z-button-base"
      [disabled]="disabled()"
      [matTooltip]="resolvedTooltip()"
      [attr.aria-label]="resolvedAriaLabel()"
    >
      @if (icon()) {
        <mat-icon>{{ icon() }}</mat-icon>
      }
      @if (!icon() && label()) {
        <span>{{ label() | translate }}</span>
      }
      <ng-content></ng-content>
    </button>
  }

  @case (MatButtonType.EXTENDED_FAB) {
    <button
      [type]="buttonType()"
      mat-fab
      extended
      [color]="color()"
      [routerLink]="routerLink() || null"
      [queryParams]="queryParams()"
      [matMenuTriggerFor]="menuTriggerFor()"
      (click)="emitClick($event)"
      [ngClass]="{
        'mat-error': color() === 'error',
        'mat-warn': color() === 'warn',
        'mat-success': color() === 'success',
        'mat-info': color() === 'info',
      }"
      class="z-button-base"
      [disabled]="disabled()"
      [matTooltip]="resolvedTooltip()"
      [attr.aria-label]="resolvedAriaLabel()"
    >
      @if (icon()) {
        <mat-icon class="s-me-1">{{ icon() }}</mat-icon>
      }
      @if (label()) {
        <span>{{ label() | translate }}</span>
      }
      <ng-content></ng-content>
    </button>
  }

  @default {
    <button
      [type]="buttonType()"
      mat-flat-button
      [color]="color()"
      [routerLink]="routerLink() || null"
      [queryParams]="queryParams()"
      [matMenuTriggerFor]="menuTriggerFor()"
      (click)="emitClick($event)"
      [ngClass]="{
        'mat-error': color() === 'error',
        'mat-warn': color() === 'warn',
        'mat-success': color() === 'success',
        'mat-info': color() === 'info',
      }"
      class="z-button-base"
      [class.w-100]="!isFabType()"
      [disabled]="disabled()"
      [matTooltip]="resolvedTooltip()"
      [attr.aria-label]="resolvedAriaLabel()"
    >
      @if (icon()) {
        <mat-icon class="s-me-1"> {{ icon() }} </mat-icon>
      }
      @if (label()) {
        <span>{{ label() | translate }}</span>
      }
      <ng-content></ng-content>
    </button>
  }
}
